export default __webpack_public_path__ + "static/media/1.dab8b0f1.jpg";